const validateIdentifier = (identifier, features) => {
  switch (identifier) {
    case 'external_id':
      return !features.profileIdfybyExtid

    case 'user_id':
    case 'customer_id':
    case 'profile_id':
    default:
      return true
  }
}

export { validateIdentifier }



// WEBPACK FOOTER //
// ./src/modules/audiences/utils/index.js